import { createSelector } from 'reselect';
import { areAnyUploadRetryableFailedFiles } from './areAnyUploadRetryableFailedFiles';
import { isAllUploadComplete } from './isAllUploadComplete';
export const isFileUploadModalRetryAllEnabled = createSelector([areAnyUploadRetryableFailedFiles, isAllUploadComplete], (anyFailedFileExist, isUploadCompleted) => anyFailedFileExist && isUploadCompleted);
//# sourceMappingURL=isFileUploadModalRetryAllEnabled.js.map